import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorStrings } from 'src/app/constants/form.constants';
import { PetClaimingInfo, PetService } from 'src/app/services/pet/pet.service';
import { Alert } from 'src/app/interfaces/alert';
import { HttpErrorResponse } from '@angular/common/http';
import { User } from 'src/app/interfaces/user';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { PetRehomePermissionRequestModalComponent } from 'src/app/modals/pet-rehome-permission-request-modal/pet-rehome-permission-request-modal.component';
import { PetRehomeInProccessModalComponent } from 'src/app/modals/pet-rehome-in-proccess-modal/pet-rehome-in-proccess-modal.component';
import { RegistrationProgressData } from 'src/app/services/registration-progress/registration-progress.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-claim-pet-by-chip',
  templateUrl: './claim-by-chip.component.html',
  styleUrls: ['./claim-by-chip.component.scss'],
})
export class ClaimPetByChipComponent implements OnInit, OnDestroy {
  errorStrings = ErrorStrings;
  loading = false;
  alert: Alert = null;
  showRehomeAlert = false;
  showVetCodeAlert = false;
  user: User;
  model: PetClaimingInfo = {
    chipNumber: '',
    vetCode: '',
    vetCodeSkipped: false,
  };
  petRehomeFormModal?: NgbModalRef;

  public petUnderTOKProcessMessage = '';
  isBrowser: boolean;

  constructor(
    private router: Router,
    private petService: PetService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.user = this.route.snapshot.data.user as User;
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  next(): void {
    this.trackEvent('registerchip::chipvetcode::submitted', this.model);
    this.closeAlert();
    this.loading = true;
    this.petService
      .claimPet(this.model)
      .subscribe(
        (pet) => {
          const queryParam = this.route.snapshot.queryParams;
          if (this.isBrowser) {
            localStorage.removeItem('enteredChipNumber');
            localStorage.removeItem('enteredChipNumberToK');
          }
          if (queryParam.r) {
            this.router.navigate(['/my-pet', pet.id, 'confirm'], {
              queryParams: { r: queryParam.r },
            });
          } else {
            this.router.navigate(['/my-pet', pet.id, 'confirm']);
          }
        },
        (err) => {
          if (err instanceof HttpErrorResponse && err.status === 400) {
            if (err.error && err.error.error_code === 'already_claimed_me') {
              this.alreadyClaimedByMeRedirection();
            } else if (
              err.error &&
              err.error.error_code === 'already_claimed'
            ) {
              this.showRehomeAlert = true;
              this.openRehomeModal();
            } else if (
              err.error &&
              err.error.error_code === 'chip_under_tok_process'
            ) {
              this.openRehomeInProccessModal();
            } else if (
              err.error &&
              err.error.error_code === 'invalid_vet_code'
            ) {
              this.showVetCodeAlert = true;
            } else if (
              err.error &&
              err.error.error_code === 'chip_not_found'
            ) {
              this.alert = {
                type: 'danger',
                message:
                  "We couldn't find a chip number matching the one you entered.",
              };
            } else {
              this.alert = {
                type: 'danger',
                message:
                  "Couldn't complete the request. Please check if the information entered are valid and try again.",
              };
            }
          } else {
            this.alert = {
              type: 'danger',
              message: 'An error has occurred. Please try again later.',
            };
          }
        }
      )
      .add(() => {
        this.loading = false;
      });
  }

  closeAlert() {
    this.showRehomeAlert = false;
    this.alert = null;
  }

  trackEvent(event: string, data?: any) {
    if (!this.isBrowser) return;
    window.analytics.track(event, data);
  }

  openRehomeModal(): void {
    const modalOptions: NgbModalOptions = {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    };

    const tokRequestModalRef = this.modalService.open(
      PetRehomePermissionRequestModalComponent,
      modalOptions
    );
    tokRequestModalRef.componentInstance.modalRef = tokRequestModalRef;
    tokRequestModalRef.componentInstance.user = this.user;
    tokRequestModalRef.componentInstance.chipNumber = this.model.chipNumber;
    tokRequestModalRef.componentInstance.vetCode = this.model.vetCode;
  }

  public openRehomeInProccessModal() {
    const modalOptions: NgbModalOptions = {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    };

    const petRehomeInProccessModalRef = this.modalService.open(
      PetRehomeInProccessModalComponent,
      modalOptions
    );
    petRehomeInProccessModalRef.componentInstance.modalRef =
      petRehomeInProccessModalRef;
  }

  toggleSkipVetCode(): void {
    this.showVetCodeAlert = false;
    this.model.vetCodeSkipped = !this.model.vetCodeSkipped;
    if (this.model.vetCodeSkipped) {
      this.model.vetCode = '';
    }
  }

  private alreadyClaimedByMeRedirection(): void {
    const claimedPet = this.user.pets.find(
      (pet) => pet.chipNumber === this.model.chipNumber.replace(/\s/g, '')
    );
    if (claimedPet) {
      this.router.navigate(['/my-pet', claimedPet.id]);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  public getProgressData(){
    const result: RegistrationProgressData = {
      isFullNameRegistrationCompleted: true,
      isPetChipNumberRegistrationCompleted: false,
      isMembershipSelectionCompleted: false,
      isWelcomePackSelectCompleted: false,
    };
    return result;
  }

  private isBase64(str: string): boolean {
    const regex = /^[A-Za-z0-9+/]*={0,2}$/;
    return regex.test(str);
  }

  ngOnInit(): void {
    if (this.route.snapshot.queryParams.chipNumber) {
      if (this.isBase64(this.route.snapshot.queryParams.chipNumber)) {
        this.model.chipNumber = atob(this.route.snapshot.queryParams.chipNumber);
      } else {
        this.model.chipNumber = this.route.snapshot.queryParams.chipNumber;
      }
    }
    if (this.isBrowser && localStorage.getItem('enteredChipNumber')) {
      this.model.chipNumber = atob(localStorage.getItem('enteredChipNumber'));
    }
    if (this.isBrowser && localStorage.getItem('enteredChipNumberToK')) {
      this.model.chipNumber = atob(localStorage.getItem('enteredChipNumberToK'));
    }
  }

  ngOnDestroy(): void {
    if (this.petRehomeFormModal) {
      this.petRehomeFormModal.dismiss('destroyed');
    }
  }
}
